
import axios from '../../definitions/axios';

export const getBlogDetails = (slug) => {
  return axios.get(`/blog/post/${slug}/` );
};
export const blogRating = ({params}) => {
  return axios.patch(`/blog/post-rating/`, params );
};
export const getComments = (slug,) => {
  return axios.get(`/blog/comment/?post=${slug}` );
};
export const postComment = ({params}) => {
  return axios.post(`/blog/comment/`, params );
};
export const rateComment = ({params}) => {
  return axios.patch(`/blog/comment-rating/`, params );
};
export const deleteComment = ({params}) => {
  return axios.delete(`/blog/comment/${params.pk}/`, params );
};